import { IPoint } from "@consts/types";

export default (first: IPoint, second: IPoint) => {
  return first.x === second.x && first.y === second.y;
}